/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ bestText: NonNullable<unknown> }} Exercise_Personal_Goal_Target_AboveInputs */

const en_us2_exercise_personal_goal_target_above = /** @type {(inputs: Exercise_Personal_Goal_Target_AboveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pick a weight above your best so far (${i?.bestText}).`)
};

const pt_br2_exercise_personal_goal_target_above = /** @type {(inputs: Exercise_Personal_Goal_Target_AboveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Escolha um peso acima do seu melhor até agora (${i?.bestText}).`)
};

const es_419_exercise_personal_goal_target_above = /** @type {(inputs: Exercise_Personal_Goal_Target_AboveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Elige un peso por encima de tu mejor marca hasta ahora (${i?.bestText}).`)
};

const pt_pt2_exercise_personal_goal_target_above = /** @type {(inputs: Exercise_Personal_Goal_Target_AboveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Escolhe um peso acima do teu melhor até agora (${i?.bestText}).`)
};

const fr_fr2_exercise_personal_goal_target_above = /** @type {(inputs: Exercise_Personal_Goal_Target_AboveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Choisis une charge au-dessus de ton meilleur actuel (${i?.bestText}).`)
};

const de_de2_exercise_personal_goal_target_above = /** @type {(inputs: Exercise_Personal_Goal_Target_AboveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wähle ein Gewicht über deinem bisherigen Bestwert (${i?.bestText}).`)
};

const it_it2_exercise_personal_goal_target_above = /** @type {(inputs: Exercise_Personal_Goal_Target_AboveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Scegli un peso superiore al tuo migliore finora (${i?.bestText}).`)
};

/**
* | output |
* | --- |
* | "Pick a weight above your best so far ({bestText})." |
*
* @param {Exercise_Personal_Goal_Target_AboveInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_goal_target_above = /** @type {((inputs: Exercise_Personal_Goal_Target_AboveInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Goal_Target_AboveInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_goal_target_above(inputs)
	if (locale === "es-419") return es_419_exercise_personal_goal_target_above(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_goal_target_above(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_goal_target_above(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_goal_target_above(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_goal_target_above(inputs)
	return en_us2_exercise_personal_goal_target_above(inputs)
});
export { exercise_personal_goal_target_above as "exercise-personal.goal_target_above" }